export enum SupportLanguageEnum {
  en = 'en',
  pl = 'pl',
  de = 'de',
  fr = 'fr',
  es = 'es',
  pt = 'pt',
  ja = 'ja',
  sv = 'sv',
}
